import ChecklistPresetItemList from "checklist/admin/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const checklistPresetRoute: RouteObject = {
  path: "checklistpreset",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: ChecklistPresetItemList,
  }]
};